import whereami from './whereami';
export var getCurrentPath = function (replaceQuery) {
    if (replaceQuery === void 0) { replaceQuery = {}; }
    if (whereami.isServerSide)
        return undefined;
    var path = window.location.pathname;
    var currentQuery = window.location.search.slice(1);
    var newQuery = new URLSearchParams(currentQuery);
    Object.entries(replaceQuery).forEach(function (query) { return newQuery.set.apply(newQuery, query); });
    var newQueryString = newQuery.toString();
    return "".concat(path).concat(newQueryString ? "?".concat(newQueryString) : '');
};
//# sourceMappingURL=get-current-path.js.map